// ========================================
// EXPORTS CENTRALIZADOS - COMPONENTES CONTRATOS
// ========================================

// Componente principal orquestador
export { default as ClientContractSection } from './ClientContractSection';

// Marcador "Próximamente" que ocupa su lugar mientras la función no está activa
export { default as ContractsComingSoon } from './ContractsComingSoon';

// Contratos y firma digital siguen detrás de "Próximamente". Mientras sea false
// se ocultan también los filtros de contratos y la tarjeta "Contratos Firmados"
// de la lista de clientes (siempre darían 0). Ponerlo a true al activarlos.
export const CONTRATOS_ACTIVOS = false;

// Componente de visualización de estado
export { default as ContractStatusCard } from './ContractStatusCard';

// Componente de formularios (upload y firma)
export { default as ContractUploadForm } from './ContractUploadForm';

// ========================================
// EXPORTS DE TIPOS (si se necesitan en el futuro)
// ========================================

// Descomentar cuando se necesiten exportar las interfaces de props
// export type { ContractStatusCardProps } from './ContractStatusCard';
// export type { ContractUploadFormProps } from './ContractUploadForm';
